import React from 'react';
import classNames from 'classnames';
import { useProgressStepper } from './ProgressStepperContext';
import { useStep } from './StepContext';

const StepLinearConnector = () => {

  const { isVertical, activeStep, centerEdgeNodes } = useProgressStepper();
  const { index, last, completed } = useStep();
  const isActiveStep = activeStep === index;
  const first = index === 0;

  const isFullBar = activeStep > index
    || (last && isActiveStep && !centerEdgeNodes)
    || (last && isActiveStep && centerEdgeNodes && completed);

  const hasTrack = isActiveStep
    && (!last || (first && centerEdgeNodes)
      || (last && !completed && centerEdgeNodes)
    );

  const hasDot = isActiveStep && !completed && !last;

  const horizontalClasses = classNames(
    'sui-absolute sui-flex sui-justify-end sui-top-[23px] sui-w-full sui-h-2px',
    {
      'sui-bg-strong': !isFullBar,
      'sui-bg-success-strongest': isFullBar,
    }
  );
  const verticalClasses = classNames(
    'sui-absolute sui-flex sui-justify-center sui-left-[15px] sui-w-2px sui-top-5',
    {
      'sui-bg-strong': !isFullBar,
      'sui-bg-success-strongest': isFullBar,
      'sui-h-full': !last,
      'sui-h-0': last,
    }
  );

  const classes = isVertical ? verticalClasses : horizontalClasses;

  const dotClasses = classNames('sui-absolute sui-h-2 sui-w-2 sui-transform sui-rounded-full sui-bg-success-strongest sui-z-100', {
    '-sui-translate-y-[3px] sui-translate-x-[4px]': !isVertical,
    'sui-self-center': isVertical,
    'sui-translate-y-[4px]': isVertical && first
  });

  const trackClasses = classNames('sui-absolute sui-bg-success-strongest', {
    'sui-w-full sui-h-full': !isVertical,
    'sui-w-2px sui-h-1/2': isVertical
  });

  const dot = (
    <div className={dotClasses} />
  );

  const track = (
    <div className={trackClasses} />
  );

  return (
    <div className={classes}>
      {hasTrack && track}
      {hasDot && dot}
    </div>
  );
};

StepLinearConnector.displayName = 'StepLinearConnector';

StepLinearConnector.propTypes = {
};

export { StepLinearConnector };
